import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { homeRoute } from '@app-constants/app.constants';
import { environment } from '@app-environments/environment';
import { GAnalyticsService } from '@app-services/g-analytics/g-analytics.service';

@Component({
  selector: 'app-course-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css', ]
})
export class courseFooterComponent implements OnInit {
  homeRoute=homeRoute;
  newHeader = environment?.newHeaderFlag;
  constructor(
    private gaService: GAnalyticsService,
    public router: Router
  ) { }

  ngOnInit(): void {
  }

  we_socialmedia(click) {
    this.gaService.webEngageEvent({
      'event': 'Social Media',
      'Click': click,
      }) 
  };

}
